/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./deviceTypesDetails.vue?vue&type=template&id=5964dd52&scoped=true"
import script from "./deviceTypesDetails.vue?vue&type=script&lang=js"
export * from "./deviceTypesDetails.vue?vue&type=script&lang=js"
import style0 from "./deviceTypesDetails.vue?vue&type=style&index=0&id=5964dd52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5964dd52",
  null
  
)

export default component.exports